<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Онлайн-трансляция с веб-камер работы склада Катрис
                </h3>
                <p>Видеотрансляция доступна в рабочие дни с 9:00 до 17:00 по московскому времени</p>
                <p>Площадь производственно-складского комплекса FOROOM составляет 9000 кв.м.<br/>
                    Адресная система хранения на 7-9 уровнях и новейшее оборудование позволяют максимально эффективно<br/> использовать пространство склада. </p>
                <hr/>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <p>Зона хранения готовой продукции и зона парковки складского транспорта</p>
                <iframe height="370px" width="100%" class="lessonsVideo" :src="'https://stream.foroom.ru/?id=4&sessidApi=' + sessionID" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-md-6">
                <p>Стеллажи для хранения комплектующих и длинномеров (трубы и отвесы)</p>
                <iframe height="370px" width="100%" class="lessonsVideo" :src="'https://stream.foroom.ru/?id=5&sessidApi=' + sessionID" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-md-12">
                <hr/>
            </div>
            <div class="col-md-6">
                <p>Стеллажи для хранения комплектующих и тубусов с тканью</p>
                <iframe height="370px" width="100%" class="lessonsVideo" :src="'https://stream.foroom.ru/?id=6&sessidApi=' + sessionID" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="col-md-6">
                <p>Общий вид территории склада и зон отгрузок</p>
                <iframe height="370px" width="100%" class="lessonsVideo" :src="'https://stream.foroom.ru/?id=10&sessidApi=' + sessionID" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
<!--                <p>Склад хранения комплектующих для производства солнцезащитных систем.</p>-->
            </div>
        </div>
    </main>
</template>

<script>
    import rm_katris from "../js/rm_katris/app";

    export default {
        name: "Translation",
        metaInfo: {
            title: 'Видеотрансляция склада Katris',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                sessionID: 0
            }
        },
        created() {
            this.sessionID = this.$session.id().split(':')[1];

            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            rm_katris.makePost('katrisService', 'videoStream', {'token': this.$session.get('jwt')}, null, function(response) {
                if (response.status != 'OK') {
                    console.log(response);
                }
            })
        }
    }
</script>

<style scoped>
</style>
